var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',{staticClass:"hc-stacked-rect",attrs:{"x":_vm.Dimention.x,"y":_vm.Dimention.y,"width":_vm.Dimention.width,"height":_vm.Dimention.height,"fill":_vm.color,"stroke":"transparent"}})}
var staticRenderFns = []

export { render, staticRenderFns }